import styled from "styled-components";

export const Heading = styled.div`
  font-family: "latobold";
  font-size: 22px;
  line-height: 26px;
  margin-bottom: 5px;
`;

export const SubHeading = styled.div`
  font-size: 18px;
  line-height: 20px;
  margin-bottom: 35px;
`;
